import React from 'react'
import { Link } from "gatsby"
import './index.scss'

const Competences = ({ title, introText, boxes, anchor }) => {
  return (
    <div className="competences">
      <section className="container">
        <div className="competences__headline headline">
          <h2 id={anchor}>{title}</h2>
          <p>{introText}</p>
        </div>
        <div className="competences__container">
          {boxes.map((box, i) => (
            <div
              className="competences__item"
              key={i}>
              {box.linkTo && <Link to={box.linkTo}></Link>}
              <h3>{box.title}</h3>
              <p>{box.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Competences
